











import Vue from 'vue';
import Tile  from "./Tile.vue";

export default Vue.extend({
  name: 'Hand',
  props: ['hand', 'mark'],
  components: {
      Tile
  },
  computed: {
    sortedHand(): [] {
      const sortedHand = this.hand
      return sortedHand.sort((a: number, b: number) => {return a - b})
    }
  },
  methods: {
    discard(t: number) {
      this.$emit('move', {
        tile: t,
        action: 0
      })
    }
  }
});
